module.exports = __webpack_public_path__ + "img/user-icon.f96d9e3c.svg";